import { CircleMarker, MapContainer, Marker, Popup, TileLayer, Tooltip, useMap } from "react-leaflet";
import L from 'leaflet';
import _ from "underscore";

import 'leaflet/dist/leaflet.css'
import { useEffect, useState } from "react";

function BoundsFitter({ bounds }) {
	const map = useMap();

	useEffect(() => {
		if (bounds) {
			map.fitBounds(bounds, {
				padding: [50, 50],
				maxZoom: 7
			});
		}
	}, [map, bounds]);

	return null;
}

function MapView(props) {
	const [mapData, setMapData] = useState(null);
	const [documentCount, setDocumentCount] = useState(null);
	const [areaBounds, setAreaBounds] = useState([[64.963051, -19.020836]]);

	const iconResize = 0.6;
	const minCircleRadius = 4;
	const maxCircleRadius = 25;


	const defaultIcon = new L.icon({
		iconAnchor: [12*iconResize, 41*iconResize],
		iconRetinaUrl: '/img/marker-icon-2x.png',
		iconSize: [25*iconResize, 41*iconResize],
		iconUrl: '/img/marker-icon.png',
		popupAnchor: [1*iconResize, -34*iconResize],
		shadowSize: [41*iconResize, 41*iconResize],
		shadowUrl: '/img/marker-shadow.png',
		tooltipAnchor: [16*iconResize, -28*iconResize]
	});

	const circleMarkerOptions = {
		color: '#000000',
		fillColor: '#006841',
		fillOpacity: 0.5,
		weight: 1
	};

	useEffect(() => {
		setMapData(props.mapData);

		let bounds = props.mapData.map(item => [item.lat, item.lng]);

		if (bounds.length > 0) {
			setAreaBounds(bounds);
		}

		let minCount = _.min(_.pluck(props.mapData, 'document_count'));
		let maxCount = _.max(_.pluck(props.mapData, 'document_count'));

		setDocumentCount({
			minCount: minCount,
			maxCount: maxCount,
			range: (value) => minCount == maxCount ? 6 : (value - minCount) * (maxCircleRadius - minCircleRadius) / (maxCount - minCount) + minCircleRadius
		});
	}, [props.mapData]);

	return <div className={props.className}>
		<MapContainer center={props.center || [64.963051, -19.020836]} zoom={props.zoom || 5}>
			<TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
				url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
			/>
			{
				mapData && mapData.map((item, index) => {
					return props.circleMarkers ? <CircleMarker center={[item.lat, item.lng]}
						pathOptions={circleMarkerOptions}
						radius={documentCount ? documentCount.range(item.document_count) : 6}
						title={item.name}
					>
						<Tooltip>{item.name}{item.document_count ? ' ('+item.document_count+')' : ''}</Tooltip>
						{
							props.popupContentFunc && <Popup>{props.popupContentFunc(item)}</Popup>
						}
					</CircleMarker> : <Marker key={index} 
						position={[item.lat, item.lng]} 
						icon={defaultIcon}
						title={item.name}
					>
						{
							props.popupContentFunc && <Popup>{props.popupContentFunc(item)}</Popup>
						}
					</Marker>
				})
			}
			<BoundsFitter bounds={areaBounds || [64.963051, -19.020836]} />
		</MapContainer>
	</div>
}

export default MapView;